module.exports = __webpack_public_path__ + "static/media/praxisraum-2.89993cad.jpg";